export const MAX_ADMIN_EMAIL_LENGTH = 120;
export const MAX_CONTRACTOR_IDC_LENGTH = 35;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const UUID_PATTERN =
	/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const normalizeContractorIdc = value => String(value || '').trim();

export const normalizeAdminEmail = value =>
	String(value || '')
		.trim()
		.toLowerCase();

export const validateAdminEmailChange = ({ currentEmail, newEmail }) => {
	const normalizedCurrentEmail = normalizeAdminEmail(currentEmail);
	const normalizedNewEmail = normalizeAdminEmail(newEmail);

	if (!normalizedNewEmail) return 'Debes indicar el nuevo correo.';
	if (normalizedNewEmail.length > MAX_ADMIN_EMAIL_LENGTH) {
		return `El correo no puede superar ${MAX_ADMIN_EMAIL_LENGTH} caracteres.`;
	}
	if (!EMAIL_PATTERN.test(normalizedNewEmail)) {
		return 'Debes indicar un correo válido.';
	}
	if (normalizedNewEmail === normalizedCurrentEmail) {
		return 'El nuevo correo debe ser distinto al correo primario actual.';
	}

	return null;
};

export const canChangeAdminEmailAndReissue = lookup =>
	lookup?.capabilities?.canChangeAdminEmailAndReissue === true;

export const isAdminOnboardingEligible = lookup =>
	lookup?.onboarding?.eligible === true;

export const isValidAdminOnboardingReissueResponse = ({
	response,
	requestedEmail,
}) => {
	const normalizedRequestedEmail = normalizeAdminEmail(requestedEmail);
	return (
		response &&
		typeof response === 'object' &&
		!Array.isArray(response) &&
		typeof response.eventId === 'string' &&
		UUID_PATTERN.test(response.eventId) &&
		response.status === 'pending' &&
		response.emailChanged === true &&
		typeof response.recipient === 'string' &&
		response.recipient === normalizedRequestedEmail
	);
};

const onboardingEligibilityMessages = {
	eligible: 'El administrador puede recibir un nuevo enlace de onboarding.',
	already_onboarded: 'El administrador ya completó su onboarding.',
	missing_initial_delivery:
		'No existe un envío inicial que pueda reemplazarse de forma segura.',
	missing_primary_email:
		'El administrador no tiene un correo primario registrado.',
};

export const getOnboardingEligibilityMessage = reason =>
	onboardingEligibilityMessages[reason] ||
	'No fue posible determinar la elegibilidad del onboarding.';

export const getOnboardingMutationError = error => {
	if (error?.httpStatus === 409) {
		return 'Los datos cambiaron o el correo ya está en uso. Consulta nuevamente la contrata antes de reintentar.';
	}
	if (error?.httpStatus === 429) {
		const retryAfter = String(error.retryAfter || '').trim();
		return retryAfter
			? `La operación está en período de espera. Reintenta después de: ${retryAfter}.`
			: 'La operación está en período de espera. Reintenta más tarde.';
	}
	if (error?.httpStatus === 403 || error?.httpStatus === 404) {
		return 'No fue posible completar la operación solicitada.';
	}
	return 'No fue posible procesar la solicitud. Puedes reintentar sin crear un envío duplicado.';
};

export const buildAcceptedOnboardingMessage = recipient =>
	`Solicitud aceptada. El correo quedó encolado para ${normalizeAdminEmail(
		recipient,
	)}.`;
